import {directionOf, getCurrentLocaleCode} from 'core/localization'
import {getLocalConfig} from 'core/localization/config'
import {switchLang} from 'core/react-router'
import saFlag from 'shared/assets/images/flags/SA.svg'
import usaFlag from 'shared/assets/images/flags/US.svg'

export const locales: any = {
  // en: {
  //   direction: 'ltr',
  //   name: 'English',
  //   flag: usaFlag,
  // },
  ar: {
    direction: 'rtl',
    name: 'العربية',
    flag: saFlag,
  },
}

export const localeCodes = Object.keys(locales)

export const getCurrentLocale = () => getLocalConfig(`locales.${getCurrentLocaleCode()}`)

